@if (!inactiveMemberForSubscription) {
  <div>
    <p class="bold">
      Assurance excédentaire.
    </p>
    <p>
      Le Fonds offre aussi l’accès à des tranches d’assurance excédentaire pouvant atteindre la somme de 10 000 000 $ par sinistre et de 20 000 000 $ par
      période d’assurance.
    </p>
    <p>
      L’achat d’une assurance excédentaire vise essentiellement à assurer une saine gouvernance de votre risque de responsabilité professionnelle.
    </p>
    <p>
      <b>Que vous soyez généraliste ou spécialiste, personne n'est à l'abri d'une réclamation demandant une indemnisation de plusieurs millions de dollars.</b>
    </p>
    <p>
      Les coûts associés à l’achat d’une assurance excédentaire doivent être évalués dans une perspective coût-bénéfice. Ce type d’assurance offre un niveau de
      protection élevé en regard des risques juridiques liés à l’exercice de la profession. Il est fortement recommandé d’y adhérer.
    </p>
    <p>
      <b>Nous vous rappelons que depuis le 1er avril 2025, les modifications au contrat-cadre prévoient une limite pour la période équivalente à deux fois votre
        couverture d'assurance par sinistre. La limite par période représente le montant maximal que nous paierons pour l'ensemble des sinistres déclarés pendant
        la période. L'assurance excédentaire augmente aussi votre protection d'assurance par période. En souscrivant, par exemple, à une assurance excédentaire pour
        une protection de 10 000 000 $ par sinistre, votre limite pour la période sera de 20 000 000 $.
      </b>
    </p>
    <p>
      <b>
        Veuillez sélectionner la limite TOTALE d'assurance souhaitée, incluant l’assurance de base obligatoire prévoyant une limite par sinistre de 2 000 000 $
        et une limite par période d’assurance de 4 000 000 $, dans le tableau ci-dessous.
      </b>
    </p>
    <p>
      <b>
        Le prix indiqué dans ce tableau correspond au  TOTAL de la prime que vous aurez à verser, incluant la prime pour l’assurance de base, la prime pour
        l'assurance excédentaire et toute surprime qui pourrait être liée à votre historique de sinistre, le cas échéant, pour la période de couverture souscrite.
      </b>
    </p>
  </div>
}

<table id="premiumTable">
  <thead>
    <tr>
      @if (!isMobileMode()) {
        <th class="selectedColumn">{{'subscription.form.premium.table.selectedHeader' | translate}}</th>
      }
      @if (hasMemberCredit()) {
        <th class="creditColumn">{{'subscription.form.premium.table.creditHeader' | translate}}</th>
      }
      <th class="premiumColumn">{{'subscription.form.premium.table.primeHeader' | translate}}</th>
      @if (hasMemberSuprime()) {
        <th class="surpremimumColumn">{{'subscription.form.premium.table.surpremimumHeader' | translate}}</th>
      }
      <th class="tpaColumn">{{'subscription.form.premium.table.tpaHeader' | translate}}</th>
      <th class="totalColumn">{{'subscription.form.premium.table.totalHeader' | translate}}</th>
    </tr>
  </thead>
  <tbody>
    @if (model?.allowSurplusRefusal) {
      <tr class="userRefuseSurplusText" class="odd" [attr.selected]="selectedPremium.userRefuseSurplus">
        <td colspan="100%" >
          <input type="radio"
            aria-label="Choix"
            name="selected"
            [value]="true"
            [(ngModel)]="selectedPremium.userRefuseSurplus"
            (change)="onUserRefuseSurplus($event)"/>
            <span class="bold"> Je ne désire pas souscrire au programme d’assurance excédentaire</span>
          </td>
        </tr>
      }
      @for (p of model?.surplus; track p; let isEven = $even) {
        @if (isMobileMode()) {
          <tr [ngClass]="{ 'odd': !isEven, 'even': isEven }" [attr.selected]="selectedPremium.surplusId == p?.premiumId">
            <td class="emptyColumn" colspan="100%" >
              <input type="radio"
                aria-label="Choix"
                name="selected"
                [value]="p?.premiumId"
                [(ngModel)]="selectedPremium.surplusId"
                (change)="onUserSelectedSurplus($event)"/>
                @if (!inactiveMemberForSubscription) {
                  <span> Assurance de </span>
                  <span class="surplusAmountValue">
                    {{  p?.premiumAmount | currencyCustom:0 }}
                  </span>
                  <span> par sinistre </span>
                  <span> / </span>
                  <span class="surplusAmountValue">
                    {{  p?.periodLimitAmount | currencyCustom:0 }}
                  </span>
                  <span> par période </span>
                }
                @if (inactiveMemberForSubscription) {
                  <span> Assurance excédentaire de  </span>
                  <span class="surplusAmountValue">
                    {{  p?.premiumAmountWithoutBase | currencyCustom:0 }}
                  </span>
                  <span> par sinistre </span>
                  <span> / </span>
                  <span class="surplusAmountValue">
                    {{  p?.periodLimitAmount | currencyCustom:0 }}
                  </span>
                  <span> par période </span>
                }
              </td>
            </tr>
          }
          <tr [ngClass]="{ 'odd': !isEven, 'even': isEven }" [attr.selected]="selectedPremium.surplusId == p?.premiumId">
            @if (!isMobileMode()) {
              <td class="selectedColumn">
                <input type="radio"
                  aria-label="Choix"
                  name="selected"
                  [value]="p?.premiumId"
                  [(ngModel)]="selectedPremium.surplusId"
                  (change)="onUserSelectedSurplus($event)"/>
                  @if (!inactiveMemberForSubscription) {
                    <span> Assurance de </span>
                    <span class="surplusAmountValue">
                      {{  p?.premiumAmount | currencyCustom:0 }}
                    </span>
                    <span> par sinistre </span>
                    <span> / </span>
                    <span class="surplusAmountValue">
                      {{  p?.periodLimitAmount | currencyCustom:0 }}
                    </span>
                    <span> par période </span>
                  }
                  @if (inactiveMemberForSubscription) {
                    <span> Assurance excédentaire de  </span>
                    <span class="surplusAmountValue">
                      {{  p?.premiumAmountWithoutBase | currencyCustom:0 }}
                    </span>
                    <span> par sinistre </span>
                    <span> / </span>
                    <span class="surplusAmountValue">
                      {{  p?.periodLimitAmount | currencyCustom:0 }}
                    </span>
                    <span> par période </span>
                  }
                </td>
              }
              @if (hasMemberCredit()) {
                <td class="creditColumn valueColumn">
                  {{ p?.calcCredit  | currencyCustom}} <span class="creditHint">*</span>
                </td>
              }
              <td class="premiumColumn valueColumn">
                {{ p?.calcPremiumBase  | currencyCustom}}
              </td>
              @if (hasMemberSuprime()) {
                <td class="surpremimumColumn valueColumn">
                  {{ p?.calcSubprime  | currencyCustom}}
                </td>
              }
              <td class="tpaColumn valueColumn">
                {{ p?.calcTPA  | currencyCustom}}
              </td>
              <td class="totalColumn valueColumn">
                {{ p?.calcTotal | currencyCustom}}
              </td>
            </tr>
          }
        </tbody>
        @if (hasMemberSuprime()) {
          <tfoot>
            <tr>
              <td>
                {{'subscription.form.premium.table.surpremimumFooter' | translate}}
              </td>
            </tr>
          </tfoot>
        }
      </table>
      @if (hasMemberCredit()) {
        <p class="creditHintDescription">
          * Crédit applicable selon montants de primes déjà payés pour la période de changement de couverture actuelle
        </p>
      }


